var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.57102 18.9583L45.4283 18.9583C47.6386 18.9583 48.5065 16.0303 46.6675 14.7779L28.478 2.39146C26.9772 1.36951 25.0221 1.36951 23.5214 2.39146L5.33187 14.7779C3.49285 16.0303 4.36079 18.9583 6.57102 18.9583Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9163 22.2083H18.4163V33.0417H11.9163V22.2083Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.083 22.2083H33.583V33.0417H40.083V22.2083Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7497 22.2083H29.2497V33.0417H22.7497V22.2083Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9319 37.4894C43.5648 36.7553 42.8146 36.2917 41.9939 36.2917L10.0054 36.2917C9.18474 36.2917 8.43451 36.7553 8.06749 37.4894L5.90082 41.8227C5.18051 43.2633 6.22809 44.9583 7.83875 44.9583H44.1606C45.7713 44.9583 46.8188 43.2633 46.0985 41.8227L43.9319 37.4894Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.859fa3c62d7c7cb1dc6d5b201935052e.svg";
export { ForwardRef as ReactComponent };